import { Api } from '../api';
import { createUrl } from '../../helpers/uri-factory';

const url = createUrl('hubspot');

export class Contact extends Api {
  constructor(http, config = {}) {
    super(http, url, 'hubspot/contact', config);
  }
}
